type PaddingProps = {
    paddingTop?: string;
    paddingBottom?: string;
};

const ROOT_FONT_SIZE = 16;

const convertToRem = (value?: string): string => {
    return value ? `${Number(value) / ROOT_FONT_SIZE}rem` : '0rem';
};

export const applyPaddings = ({ paddingTop, paddingBottom }: PaddingProps) => {
    return {
        paddingTop: convertToRem(paddingTop),
        paddingBottom: convertToRem(paddingBottom),
    };
};
